import React, { useState, useContext } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import { productsPathTo } from '../utils/Api';
import { UserContext } from '../contexts/UserContext';

const NewProductDialog = ({ showDialog, onClose }) => {
  const currentUser = useContext(UserContext);
  const [newProduct, setNewProduct] = useState({
    title: '',
    provider_id: currentUser.provider_id
  });

  if (!showDialog) {
    return null;
  }

  const resetProduct = () => {
    setNewProduct({
      title: '',
      provider_id: currentUser.provider_id
    });
  };

  const handleChange = (event) => {
    setNewProduct({
      ...newProduct,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await productsPathTo.save(newProduct);
      resetProduct();
      onClose(response.data);
    } catch (error) {
      console.error('Error saving new product:', error);
      // Optionally show error in Snackbar (requires context access)
    }
  };
  
  const handleOnClose = () => {
    resetProduct();
    onClose();
  }

  return (
    <Dialog open={showDialog} onClose={handleOnClose}>
      <DialogTitle>Adicionar novo produto</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          name="title"
          label="Nome"
          type="text"
          value={newProduct.title}
          onChange={handleChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOnClose} color="primary" variant="outlined">
          Cancelar
        </Button>
        <Button onClick={handleSubmit} color="primary" variant="contained" autoFocus>
          Adicionar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewProductDialog;
